import { FC, useState } from "react"
import ReactApexChart from "react-apexcharts"
import './proveedoressalidas.css'
import { ProveedoresSalidasKPI } from "./ProveedoresSalidasKPI/ProveedoresSalidasKPI"

export const ProveedoresSalidas:FC<any> = (props):JSX.Element => {

  const { comparativa, kpisSalidas, stateDonutInternos, stateEntradasProveedorInterno,filtered,tabID } = props

    const [ state, setState ] = useState<any>(stateDonutInternos)

    const [stateEntradas, setStateEntradas] = useState<any>(stateEntradasProveedorInterno)
   
    return (
        <div className="proveedoressalidas__wrapper">
            <div className="psalidas-top" style={{width:'99%'}}>
                <div className="psalidas-kpicontainer">
                  {
                    kpisSalidas.map((kpi:any,index:number) => {
                      if(index !== 1) {
                        return(
                          <ProveedoresSalidasKPI key={index} title={kpi.title} valueA={kpi.valueA} valueB={kpi.valueB} comparativa={comparativa} filtered={filtered} tabID={tabID} />
                        )
                      } 
                      
                    })
                  }
                </div>
                {
                  state.series.length === 0 || state.series.length === [0, 0].length && state.series.every((value:any, index:any) => value === [0, 0][index])?
                  <div className="donut-internos" style={{border:'1px solid lightgray',height:'100%'}}>
                    <span style={{fontFamily:'var(--roboto-light)',width:'60%',textAlign:'center'}}><i>[No existen datos para los filtros aplicados.]</i></span>
                  </div>
                  :
                  <ReactApexChart className="donut-internos" options={state.options} series={state.series.length === 0? [0.1,0.1] : state.series} type="donut" height={'99%'}/>
                }
            </div>
            <div className="chart-of" style={{width:'100%',height:'60%'}}>
              <ReactApexChart options={stateEntradas?.options} series={stateEntradas?.series?.map((s:any) => ({...s,data:s?.data?.map((d:any) => {if(d === 0) {
                    return 0.000001
                }
                return d
                })
                }))} type="bar" height={'100%'} />
            </div>
        </div>
    )
}